// extracted by mini-css-extract-plugin
export default {"iconClose":"styles-scoped__iconClose--G4gz0","errorWrapper":"styles-scoped__errorWrapper--NDQe8"};